import { useAuth } from 'features/auth';
import { useSchool } from 'features/school';

const ChatBot = () => {
  const { schoolAlias } = useSchool();
  const { fullName, loginEmail } = useAuth();

  return loginEmail === 'felipe@melver.com.br' || loginEmail === 'bruno.bernardo@melver.com.br' ? (
    <div id="educa-chat-gpt" data-custom-id={fullName}></div>
  ) : (
    <></>
  );
};

export default ChatBot;
